<template>
  <div
    class="full-image-title-text"
    :class="props.type.includes('bottom-space') ? 'bottom-space' : ''"
    v-if="
      props.content.fullImage?.[0] ||
      (props.content.fullVideoUrl && props.content.fullVideoUrlPreview)
    "
  >
    <div>
      <WidgetVideo
        v-if="props.content.fullVideoUrl"
        :video-url="props.content.fullVideoUrl"
        :video-url-preview="props.content.fullVideoUrlPreview"
        :autoplay="true"
        :loop="true"
        :button-txt="props.content.fullVideoButtonText"
        class="ratio-full-screen"
        :class="{ 'ratio-header': props.type.includes('for-header') }"
      />
      <div
        v-else-if="props.content.fullImage?.[0]"
        class="ratio-full-screen"
        :class="{
          'full-image-title-text__image': props.type.includes('default'),
          'ratio-header': props.type.includes('for-header'),
        }"
      >
        <WidgetPicture
          :image="{
            landscape: props.content.landscape?.[0],
            portrait: props.content.mobile?.[0],
          }"
          :alt="props.content.fullImage[0].title"
          class="ratio-full-screen"
          :class="{
            'full-image-title-text__image': props.type.includes('default'),
            'ratio-header': props.type.includes('for-header'),
          }"
        />
      </div>
      <div
        v-if="props.content.imageVideoText"
        class="title-base mobile-text hide-for-large"
      >
        <div>
          <div v-html="props.content.imageVideoText" />
        </div>
      </div>
      <!--   v-if="props.content.imageVideoTitle || props.content.imageVideoText" -->
      <div class="text-overlay" :class="props.type">
        <div class="top-left title-big4 is-medium-bold">
          <div v-if="props.content.imageVideoTitle" class="title">
            <div v-html="props.content.imageVideoTitle" />
          </div>
          <div class="cta" v-if="props.content.linkDefault">
            <NuxtLink :to="localePath(props.content.linkDefault)">
              <div
                class="text-medium5 default-icon-btn is-medium-bold is-white text-image__cta"
              >
                <span v-html="props.content.label" />
                <ArrowIcon alt="Arrow icon" class="icon-arrow" />
              </div>
            </NuxtLink>
          </div>
        </div>
        <div class="title-base top-right show-for-large">
          <div v-if="props.content.imageVideoText">
            <div v-html="props.content.imageVideoText" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ArrowIcon from '@/assets/img/ico/arrow-mobile.svg'

const props = defineProps({
  content: {
    type: Object,
    default: () => ({}),
  },
  type: {
    type: String,
    default: '',
  },
})
</script>

<script>
export default {
  name: 'FullImageTitleText',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
